import React, { forwardRef } from 'react'
import { Box, Widget } from '@maui/elements'

export const DetailsSection = forwardRef(({ title, headerSlot, children, ...props }, ref) => {
  return (
    <Box ref={ref}>
      <Widget
        width="100%"
        mb="spaceGapXLarge"
        title={title}
        topRight={headerSlot}
        {...props}
      >
        {children}
      </Widget>
    </Box>
  )
})

DetailsSection.displayName = 'DetailsSection'
